<template>
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
    <title>Small illustration of glass cleaner bottle with magenta cleaner fluid inside</title>
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linejoin="round"
      stroke-width="2"
      d="M35.496 12.229s-10.527.279-8.436 8.366L34.417 49H11.199l7.355-28.405c2.093-8.087-4.74-10.197-4.74-10.197L17.858 7h17.638v5.229z"
      clip-rule="evenodd"
    />
    <path fill="#FF0068" fill-rule="evenodd" d="M28.246 38.08l1.917 7.536H15.445l1.946-7.535h10.855z" clip-rule="evenodd" />
    <path
      stroke="#05070F"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M38.006 21.361c-4.256 0-7.739-3.482-7.739-7.738M19.391 19.34h6.834"
    />
    <path
      fill="#FF0068"
      fill-rule="evenodd"
      d="M42.166 9.59c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5 0-.828.672-1.5 1.5-1.5.829 0 1.5.672 1.5 1.5zM47.355 9.59c0 .829-.672 1.5-1.5 1.5-.829 0-1.5-.671-1.5-1.5 0-.828.671-1.5 1.5-1.5.828 0 1.5.672 1.5 1.5zM52.543 9.59c0 .829-.672 1.5-1.5 1.5-.829 0-1.5-.671-1.5-1.5 0-.828.671-1.5 1.5-1.5.828 0 1.5.672 1.5 1.5z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HousekeepingIcon',
};
</script>
